/** @jsxImportSource @emotion/react */

import { useMemo } from "react";
import useDocumentDetails from "../../../../../../hooks/useDocumentDetails";
import DetailsSectionColumn from "../../../../../../components/Details/components/Main/Grid/DetailsSectionColumn";
import { DetailsRowValueVariants } from "../../../../../../components/Details/components/Main/Grid/DetailsRowValue";
import { DetailsRowProps } from "../../../../../../components/Details/components/Main/Grid/DetailsRow";
import FarmerData from "../../FarmerData";
import BeneficiaryData from "../../BeneficiaryData";
import PropertyData from "../../PropertyData";
import CropData from "../../CropData";

const BasicInfo = () => {
  const {
    documentData: { crop, property, farmer, beneficiary },
  } = useDocumentDetails();

  const insuranceInfo = useMemo<DetailsRowProps[]>(() => {
    return [
      {
        label: "Produtor",
        value: { text: farmer!.name!, Component: FarmerData },
        variant: DetailsRowValueVariants.Modal,
      },
      {
        label: "Beneficiário",
        value: { text: beneficiary?.name!, Component: BeneficiaryData },
        variant: DetailsRowValueVariants.Modal,
      },
      {
        label: "Lavoura // Área",
        value: {
          text: `${crop?.cultureName} // ${crop?.area} ha`,
          Component: CropData,
        },
        variant: DetailsRowValueVariants.Modal,
      },
      {
        label: "Propriedade",
        value: {
          text: `${property?.name ? property?.name + " // " : ""} ${
            property?.address?.city
          } - ${property?.address?.state}`,
          Component: PropertyData,
        },
        variant: DetailsRowValueVariants.Modal,
      },
    ];
  }, [crop, property, farmer]);

  return <DetailsSectionColumn xs={12} sm={6} rows={insuranceInfo} />;
};

export default BasicInfo;
